export type StudentSelectedTime = {
  slotId: string;
  slotName: string;
  date: string;
  meridiem: string;
};

export type CollectionTimeSlot = {
  slotId: string;
  slotName: string;
  isAvailable: boolean;
  isExpired: boolean;
  meridiem: string;
};

type CardCollectionSlot = {
  date: string;
  allExpired: boolean;
  slots: CollectionTimeSlot[];
};

export type StudentBookInfo = {
  applicantName: string;
  closedNotes?: string;
  cardCollectionSlots: CardCollectionSlot[];
};

export enum OVTS_COMPLETION_STATUS {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE',
  EXEMPTED = 'EXEMPTED',
  NOT_CREATED = 'NOT_CREATED',
}
